import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import { Box, Chip, Collapse, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { getIcon } from '../../../components/IconSelect/icons';
import { GadgetDto } from '../../../types/gadgets.types';
import { ServiceInfo } from '../../../types/serviceInfo.types';
import styles from '../../GadgetsPage/styles.module.css';
import { getIconByName } from '../utils/ServiceInfoIcons';
import DeleteIcon from '@mui/icons-material/Delete';

interface RowProps {
  onServiceInfoAdd: () => void;
  onServiceInfoEdit: (serviceInfo: ServiceInfo) => void;
  onServiceInfoPriceEdit: (serviceInfo: ServiceInfo) => void;
  onServiceInfoHub: (serviceInfoId: ServiceInfo) => void;
  onServiceInfoDelete: (serviceInfoId: ServiceInfo) => void;
  row: GadgetDto;
}

export const Row = ({ row, onServiceInfoAdd, onServiceInfoEdit, onServiceInfoPriceEdit, onServiceInfoHub, onServiceInfoDelete }: RowProps) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell sx={{ width: '20px' }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          <div className={styles.gadgetName}>
            <div className={styles.icon}>{getIcon(row.icon).icon}</div>
            <Typography>{row.name}</Typography>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              className={styles.subTableContainer}
              sx={{ margin: 1, padding: 2 }}
            >
              <div className={styles.header}>
                <Typography variant="h6">Service info</Typography>
                <Button
                  variant="contained"
                  onClick={onServiceInfoAdd}
                  startIcon={<AddIcon />}
                >
                  ADD
                </Button>
              </div>
              <Table size="small">
                <TableBody>
                  {row?.serviceInfo?.length ? (
                    <>
                      {row.serviceInfo.map((serviceInfo: any) => (
                        <TableRow key={serviceInfo.id}>
                          <TableCell component="th" scope="row">
                            <div className={styles.serviceIconCell}>
                              {getIconByName(serviceInfo.icon)}
                              <span>{serviceInfo.titleEn}</span>
                              {serviceInfo.isPopular && (
                                <Chip
                                  color="success"
                                  label={`Mega-menu ${serviceInfo.menuPriority || 0}`}
                                  size="small"
                                />
                              )}
                            </div>
                          </TableCell>
                          <TableCell align="right">
                            <div className={styles.action}>
                                <PriceChangeIcon
                                  onClick={() => {
                                    onServiceInfoPriceEdit(serviceInfo);
                                  }}
                                />
                              <EditIcon
                                onClick={() => {
                                  onServiceInfoEdit(serviceInfo);
                                }}
                              />
                              <DeviceHubIcon
                                onClick={() => {
                                  onServiceInfoHub(serviceInfo);
                                }}
                              />
                              <DeleteIcon
                                onClick={() => {
                                  onServiceInfoDelete(serviceInfo);
                                }}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <Typography variant="h6">No Content</Typography>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
